import React from 'react'

const TopRatedEvents = () => {
  return (
    <><h2>Top rated</h2><h3>Refresh me, and you will still be on this page.</h3></>
  )
}

export default TopRatedEvents